// src/utils/groupUtils.js

function removeRepWithNumber(str) {
  return str.replace(/_?rep\d+/gi, "");
}

function removeStandaloneNumber(str) {
  return str
    .replace(/(^|_)\d+(_|$)/g, "$1$2")
    .replace(/__/g, "_")
    .replace(/^_|_$/g, "");
}

function groupBySimilarNames(files) {
  const keys = Object.keys(files);
  let groups = {};
  let any_group = false;

  for (let i = 0; i < keys.length; i++) {
    const id = keys[i];
    const name = files[id];
    const stripped_name = removeRepWithNumber(name);

    if (stripped_name in groups) {
      groups[stripped_name].push(id);
      any_group = true;
    } else {
      groups[stripped_name] = [id];
    }
  }

  if (!any_group) {
    groups = {};
    for (let i = 0; i < keys.length; i++) {
      const id = keys[i];
      const name = files[id];
      const stripped_name = removeStandaloneNumber(name);

      if (stripped_name in groups) {
        groups[stripped_name].push(id);
        any_group = true;
      } else {
        groups[stripped_name] = [id];
      }
    }
  }

  return groups;
}

function findCommonParts(strings) {
  if (!strings || strings.length === 0) return "";

  const splitArrays = strings
    .filter((s) => typeof s === "string")
    .map((s) => s.replace(/\./g, "_").split("_"));

  if (splitArrays.length === 0) return "";

  const firstArray = splitArrays[0];
  const commonParts = [];

  for (let i = 0; i < firstArray.length; i++) {
    const currentPart = firstArray[i];

    if (currentPart && currentPart.toLowerCase().startsWith("rep")) {
      continue;
    }

    const allHaveSamePart = splitArrays.every(
      (array) => array.length > i && array[i] === currentPart
    );

    if (allHaveSamePart && currentPart) {
      commonParts.push(currentPart);
    }
  }

  const result = commonParts.join("_");
  return result || "Group";
}

export function autoFillGroups(displayedFiles, currentGroups) {
  const file_id_to_name_dict = {};
  let groupIndex = 0;

  for(const groupName in currentGroups) {
    var currentFiles = currentGroups[groupName].files
    if (currentFiles.length > 0) {
      groupIndex++;
    }
  }

  displayedFiles.forEach((file) => {
    file_id_to_name_dict[file.file_id] = file.file_name;
  });

  const grouped_files = groupBySimilarNames(file_id_to_name_dict);
  const updatedGroups = currentGroups;
  const groupNames = Object.keys(grouped_files);
  
  for (const groupName of groupNames) {
    if (groupIndex >= updatedGroups.length) break;
    const fileIds = grouped_files[groupName];
    updatedGroups[groupIndex] = {
      ...updatedGroups[groupIndex],
      files: fileIds,
    };
    groupIndex++;
  }

  return updatedGroups;
}

export function autoLabelGroups(groups, allFiles, stripSeqType=false) {
  return groups.map((group) => {
    if (!group.files || group.files.length === 0) {
      return group;
    }

    const fileNames = group.files
      .map((fileId) => {
        const file = allFiles.find(
          (f) => String(f.file_id || f.id) === String(fileId)
        );
        return file ? file.file_name : null;
      })
      .filter(Boolean);

    if (fileNames.length === 0) {
      return group;
    }

    var commonStr = findCommonParts(fileNames);

    if (stripSeqType && commonStr) {
      // strip any seq types from the end of commonstr
      const seqTypeSuffixes = ["_rpf", "_rna"]
      const suffixPattern = new RegExp(
        `(${seqTypeSuffixes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})$`
      );
      commonStr = commonStr.replace(suffixPattern, "");
    }

    return {
      ...group,
      name: commonStr || group.name,
    };
  });
}

export function getAvailableFiles(allFiles, groups) {
  const assignedFileIds = new Set();

  groups.forEach((group) => {
    if (group.files && Array.isArray(group.files)) {
      group.files.forEach((fileId) => {
        assignedFileIds.add(String(fileId));
      });
    }
  });

  const availableFiles = allFiles.filter((file) => {
    const fileId = String(file.file_id || file.id);
    return !assignedFileIds.has(fileId);
  });

  return availableFiles;
}

export function getGroupFiles(groupId, groups, allFiles) {
  const group = groups.find((g) => g.id === groupId);
  if (!group || !group.files) {
    return [];
  }

  const files = group.files
    .map((fileId) => {
      const file = allFiles.find(
        (f) => String(f.file_id || f.id) === String(fileId)
      );
      return file;
    })
    .filter(Boolean);

  return files;
}
